<template>
  <v-container max-width="100%" style="margin-top: 2%">
    <template>
      <v-row justify="center">
        <v-dialog v-model="confirmDialog" persistent max-width="500" style="border-radius: 10px">
          <v-card>
            <v-card-title class="headline">
              <span style="color: #d60000">{{ $t('permissoes.messages.systemMessage') }}</span>
            </v-card-title>
            <v-card-text>
              <span style="color: #d60000">{{ mensagemdialog }}</span>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn color="red accent-4" class="white--text" @click="confirmDialog = false">
                {{ messageDismissButton }}
              </v-btn>
              <v-btn
                v-if="showConfirmButton"
                color="red accent-4"
                class="white--text"
                @click="deleteFromDatabase"
              >
                {{ messageConfirmButton }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>

    <v-container>
      <merus-data-table
        :headers="headersWithProperties"
        :items="permissoes"
        :loading="loading"
        :loading-text="$t('permissoes.loading')"
        sort-by="descricao_permissao_translated"
        dense
        class="elevation-7"
        locale="pt"
        style="border-radius: 10px"
        @update:displayedItems="displayedItemsForExport = $event"
      >
        <template v-slot:toolbar>
          <CadastroToolbar
            :title="$t('permissoes.title')"
            :token="token"
            :items="displayedItemsForExport !== null ? displayedItemsForExport : permissoes"
            hide-search
          >
            <template v-slot:add>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    color="primary"
                    dark
                    small
                    fab
                    class="mb-2 mr-2"
                    :loading="auditing"
                    @click="openAudit"
                  >
                    <v-icon>mdi-clipboard-search-outline</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('permissoes.audit.tooltip') }}</span>
              </v-tooltip>
              <v-btn color="primary" dark small class="mb-2" fab @click="openCreate">
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </template>
          </CadastroToolbar>
        </template>

        <template v-slot:item.actions="{ item }">
          <v-icon small class="mr-2" color="green" @click="editItem(item)">mdi-pencil</v-icon>
          <v-icon small class="mr-2" color="red" @click="deleteItem(item)">mdi-delete</v-icon>
        </template>
      </merus-data-table>

      <PermissaoWizardDialog
        v-model="wizardOpen"
        :token="token"
        :edited-permission="editedPermission"
        @saved="onWizardSaved"
        @closed="editedPermission = null"
      />

      <v-dialog v-model="auditDialog" max-width="760" scrollable>
        <v-card>
          <v-card-title class="headline">
            {{ $t('permissoes.audit.title') }}
          </v-card-title>
          <v-divider />
          <v-card-text style="max-height: 60vh">
            <div v-if="auditing" class="text-center py-8">
              <v-progress-circular indeterminate color="primary" class="mb-3" />
              <div>{{ $t('permissoes.audit.scanning') }}</div>
            </div>

            <v-alert
              v-else-if="auditResults.length === 0"
              type="success"
              dense
              outlined
              class="mt-4"
            >
              {{ $t('permissoes.audit.upToDate') }}
            </v-alert>

            <template v-else>
              <p class="mt-4 mb-2">
                {{ $t('permissoes.audit.outdatedCount', { count: auditResults.length }) }}
              </p>
              <v-data-table
                v-model="selectedResults"
                :headers="auditHeaders"
                :items="auditResults"
                item-key="id_permissao"
                show-select
                dense
                hide-default-footer
                :items-per-page="-1"
                class="elevation-1"
              >
                <template v-slot:item.missing="{ item }">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-chip x-small color="orange darken-2" dark v-on="on">
                        {{ item.missingReadCodes.length }}
                      </v-chip>
                    </template>
                    <span>{{ item.missingReadCodes.join(', ') }}</span>
                  </v-tooltip>
                </template>
              </v-data-table>
            </template>
          </v-card-text>
          <v-divider />
          <v-card-actions>
            <v-spacer />
            <v-btn text :disabled="updating" @click="auditDialog = false">
              {{ $t('permissoes.audit.close') }}
            </v-btn>
            <v-btn
              v-if="auditResults.length > 0"
              color="primary"
              dark
              :loading="updating"
              :disabled="selectedResults.length === 0 || auditing"
              @click="updateSelected"
            >
              {{ $t('permissoes.audit.updateSelected', { count: selectedResults.length }) }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </v-container>
</template>

<script>
import apiController from "@/utils/apiController";
import EventBus from "@/utils/eventBus";
import CadastroToolbar from "./Toolbars/CadastroToolbar.vue";
import MerusDataTable from "./Tables/MerusDataTable.vue";
import PermissaoWizardDialog from "./PermissaoWizardDialog.vue";
import formatPermissaoDescricao, {
  UNIT_ACCESS_TRANSLATION_KEY,
  extractUnitCodeFromDescricao,
} from "@/utils/formatPermissaoDescricao";
import {
  auditScreenPermission,
  runWithConcurrency,
} from "@/utils/screenPermissionAudit";

export default {
  components: {
    CadastroToolbar,
    MerusDataTable,
    PermissaoWizardDialog,
  },
  data: () => ({
    confirmDialog: false,
    showConfirmButton: false,
    mensagemdialog: "",
    messageDismissButton: "",
    messageConfirmButton: "",
    token: null,
    loading: false,
    permissoes: [],
    displayedItemsForExport: null,
    auditDialog: false,
    auditing: false,
    updating: false,
    auditResults: [],
    selectedResults: [],
    wizardOpen: false,
    editedPermission: null,
    deletedItem: {
      id_permissao: null,
      descricao_permissao: null,
    },
  }),
  created() {
    this.token = sessionStorage.getItem("api");
    this.initialize();
  },
  computed: {
    headers() {
      return [
        { text: this.$t("permissoes.headers.id"), value: "id_permissao", align: " d-none" },
        {
          text: this.$t("permissoes.headers.permission"),
          value: "descricao_permissao_translated",
        },
        { text: this.$t("permissoes.headers.actions"), value: "actions", sortable: false, align: "end" },
      ];
    },
    headersWithProperties() {
      return this.headers.map((header) => ({
        ...header,
        filtrable: header.filtrable !== false,
        sortable: header.sortable !== false,
      }));
    },
    auditHeaders() {
      return [
        { text: this.$t("permissoes.headers.permission"), value: "descricao" },
        { text: this.$t("permissoes.audit.headers.screen"), value: "screenName" },
        {
          text: this.$t("permissoes.audit.headers.missing"),
          value: "missing",
          sortable: false,
          align: "center",
        },
      ];
    },
  },
  watch: {
    "$i18n.locale"() {
      this.initialize();
    },
  },
  methods: {
    initialize() {
      this.loading = true;
      apiController.request(apiController.endpoints.getPermissoesgranulares, {
        onSuccess: (response) => {
          this.permissoes = response.data
            .filter((permissao) => {
              if (permissao.translation_key !== UNIT_ACCESS_TRANSLATION_KEY) {
                return true;
              }
              const hasCod =
                permissao.cod_unidade != null && String(permissao.cod_unidade).trim() !== "";
              return hasCod || !!extractUnitCodeFromDescricao(permissao.descricao_permissao);
            })
            .map((permissao) => ({
              ...permissao,
              descricao_permissao_translated: formatPermissaoDescricao(permissao),
            }));
          this.loading = false;
        },
        onError: () => {
          this.loading = false;
        },
      });
    },
    openCreate() {
      this.editedPermission = null;
      this.wizardOpen = true;
    },
    editItem(item) {
      this.editedPermission = { ...item };
      this.wizardOpen = true;
    },
    onWizardSaved(data) {
      EventBus.$emit("show-alert", {
        mensagem: data.mensagem,
        tipo: data.erro ? "error" : "success",
      });
      this.initialize();
    },
    async auditPermission(id) {
      try {
        const response = await apiController.request(
          apiController.endpoints.getRecursospermissao,
          { params: { id }, silent: true }
        );
        return auditScreenPermission(response.data);
      } catch (e) {
        return null;
      }
    },
    openAudit() {
      this.auditDialog = true;
      this.runAudit();
    },
    async runAudit() {
      if (this.auditing) return;
      this.auditing = true;
      this.auditResults = [];
      this.selectedResults = [];
      try {
        const results = await runWithConcurrency(
          [...this.permissoes],
          8,
          async (permissao) => {
            const audit = await this.auditPermission(permissao.id_permissao);
            if (audit && audit.isScreen && audit.knownScreen && audit.outdated) {
              return {
                id_permissao: permissao.id_permissao,
                descricao:
                  permissao.descricao_permissao_translated ||
                  permissao.descricao_permissao,
                screenName: audit.screenName,
                missingReadCodes: audit.missingReadCodes,
              };
            }
            return null;
          }
        );
        this.auditResults = results
          .filter(Boolean)
          .sort((a, b) => a.descricao.localeCompare(b.descricao));
        this.selectedResults = [...this.auditResults];
      } finally {
        this.auditing = false;
      }
    },
    async updateSelected() {
      if (this.updating || this.selectedResults.length === 0) return;
      this.updating = true;
      try {
        const recursosResponse = await apiController.request(
          apiController.endpoints.getallRecursos,
          { silent: true }
        );
        const endpointByCod = new Map();
        for (const recurso of recursosResponse.data) {
          if (recurso.descricao_tipo_recurso === "Endpoint") {
            endpointByCod.set(recurso.cod_recurso, recurso);
          }
        }

        const pairs = [];
        const affectedIds = new Set();
        const unresolved = new Set();
        let addedCount = 0;

        for (const result of this.selectedResults) {
          for (const cod of result.missingReadCodes) {
            const recurso = endpointByCod.get(cod);
            if (recurso) {
              pairs.push([result.id_permissao, recurso.id_recurso]);
              affectedIds.add(result.id_permissao);
              addedCount += 1;
            } else {
              unresolved.add(cod);
            }
          }
        }

        if (pairs.length > 0) {
          await apiController.request(
            apiController.endpoints.insertRecursospermissaobulk,
            { data: pairs, silent: true }
          );
        }

        let mensagem = this.$t("permissoes.audit.done", {
          permissions: affectedIds.size,
          resources: addedCount,
        });
        if (unresolved.size > 0) {
          mensagem += ` ${this.$t("permissoes.audit.unresolved", {
            count: unresolved.size,
          })}`;
        }
        EventBus.$emit("show-alert", {
          mensagem,
          tipo: unresolved.size > 0 ? "warning" : "success",
        });

        // re-scan so resolved permissions drop off and any leftovers remain
        await this.runAudit();
      } catch (error) {
        EventBus.$emit("show-error", { error });
      } finally {
        this.updating = false;
      }
    },
    deleteItem(item) {
      this.deletedItem = Object.assign({}, item);
      this.mensagemdialog = this.$t("permissoes.messages.confirmDelete", {
        permissionName: item.descricao_permissao_translated || item.descricao_permissao,
      });
      this.showConfirmButton = true;
      this.messageDismissButton = this.$t("permissoes.messages.no");
      this.messageConfirmButton = this.$t("permissoes.messages.yes");
      this.confirmDialog = true;
    },
    deleteFromDatabase() {
      this.confirmDialog = false;
      apiController.request(apiController.endpoints.deletePermissao, {
        data: this.deletedItem,
        onSuccess: (response) => {
          EventBus.$emit("show-alert", {
            mensagem: response.data.mensagem,
            tipo: response.data.erro ? "error" : "success",
          });
          this.initialize();
        },
      });
    },
  },
};
</script>